import { useRef, useEffect, useMemo } from "react"
import { get } from "utils/helpers"
import { columnPropTypes, rowPropTypes } from "components/ui/Table/tablePropsTypes"
import { PropTypes } from "prop-types"
import useScreenWidth from "hooks/use_screen_width"

const TableCell = ({ column = {}, row = {}, isDragging = false }) => {
  const cellRef = useRef(null)
  const width = useRef(null)
  const { screenWidth } = useScreenWidth()

  const isFixedWidth = useMemo(() => !!column.style?.width, [column])

  useEffect(() => {
    if (cellRef?.current) {
      const rect = cellRef.current.getBoundingClientRect()
      width.current = `${rect.width}px`
    }
  }, [cellRef, screenWidth])

  if (!isFixedWidth && cellRef.current?.style) {
    if (isDragging && !cellRef.current.style.width) cellRef.current.style.width = width.current
    if (!isDragging && cellRef.current.style.width) cellRef.current.style.removeProperty("width")
  }

  const renderProps = column.renderProps ? column.renderProps(row, column) : {}

  return (
    <td
      ref={cellRef}
      className={column.className}
      style={column.style}
      colSpan={column.colSpan}
      {...renderProps}
    >
      {column.render ? column.render(row, column) : get(row, column.cell, "")}
    </td>
  )
}

TableCell.propTypes = {
  column: columnPropTypes,
  row: rowPropTypes,
  isDragging: PropTypes.bool
}

export default TableCell
